import React from "react";
import { openExternalUrl } from "../external_link";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import DocumentDownloadScreen from "./DocumentDownloadScreen";
import ErrorScaffold from "./ErrorScaffold";
import { isDefined } from "./Generic/IsDefined";
import { pdfDocuments } from "./ImportantInformation/pdfDocuments";

interface Props {
  documentType: string;
  onClickGoBack: () => void;
}

const DocumentDownloadActivity = (props: Props) => {
  const document = pdfDocuments.find((doc) => doc.type === props.documentType);

  function downloadPdf() {
    if (!isDefined(document)) {
      return;
    }
    openExternalUrl(document.pdfUrl);
  }

  if (!isDefined(document)) {
    return (
      <ErrorScaffold
        onClickGoBack={props.onClickGoBack}
        title={translate(STRINGS.ERROR)}
        message={translate(STRINGS.DOCUMENT_IS_MISSING)}
      />
    );
  }

  return (
    <DocumentDownloadScreen
      imagePreview={document.imagePreview}
      title={document.title}
      onClickDownload={downloadPdf}
      onClickGoBack={props.onClickGoBack}
    />
  );
};

export default DocumentDownloadActivity;
